<template>
  <div class="container extra-style-preview">
    <van-overlay :show="showOverlay" @click="onClickHide" z-index="3">
      <div class="overlay-wrapper">
        <div>
          点击页面右上角分享集赞<img class="arrow" src="../../assets/images/extra-style/arrow.png">
        </div>
      </div>
    </van-overlay>

    <photo-preview ref="photoPreview" @checkedUser="checkedUser">
      <!-- <van-col span="6" class="share-icon" @click="shareImage">
        <van-icon name="share" />
        <div>分享<br>集赞</div>
      </van-col> -->
    </photo-preview>
  </div>
</template>

<script>
import PhotoPreview from './components/photo-preview'
import { userUtils } from '@/utils/auth'
export default {
  name: 'ExtraStylePhotoPreview',
  components: {
    PhotoPreview
  },
  data () {
    return {
      showOverlay: true
    }
  },
  created () {
    if (!this.$route.query.photoId) {
      this.$router.push({ name: 'extra-style' })
    }
  },
  methods: {
    onClickHide () {
      this.showOverlay = false
    },
    checkedUser () {
      const clientInfo = userUtils.getClientInfo()
      if (!clientInfo || clientInfo.clientId !== this.$refs.photoPreview.clientId) {
        const query = {
          photoId: this.$route.query.photoId
        }
        this.$router.push({ path: '/extra-style/photo-support', query: query })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  .share-icon {
    padding-top: 10px;
    font-size: 40px;
    color: #22545b;
    div {
      font-size: 18px;
    }
  }
  .overlay-wrapper {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    height: 100%;
    line-height: 120px;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    .arrow {
      padding-left: 10px;
      width: 80px;
    }
  }
}
</style>
